module.exports = __webpack_public_path__ + "img/sketch.2e236add.png";